import React, { useState, useEffect, useRef } from "react";

import { Form } from "react-bootstrap";
import { useHistory, useRouteMatch } from "react-router-dom";

import Select from "react-select";
import axios from "axios";
import { environment } from "../../environment";

import Swal from "sweetalert2";
import { LinkContainer } from "react-router-bootstrap";
import { Button } from "react-bootstrap";
import NavbarNew from "../Components/NavbarNew";

const EditTicket = (match, props) => {
  const [optionForName, setOptionForName] = useState([]);
  const [optionsForAssign, setOptionsForAssign] = useState([]);
  const [optionForTicketCategory, setOptionForTicketCategory] = useState([]);
  const [optionForSubCategory, setOptionForSubCategory] = useState([]);
  const [uploadFiles, setUploadFiles] = useState([]);
  const [ticketError, setTicketError] = useState({});
  const [subCategoryError, setSubCategoryError] = useState({});
  const [customerError, setCustomerError] = useState({});
  const [priorityError, setPriorityError] = useState({});
  const [loading, setLoading] = useState(false);
  const [customerEmail, setCustomerEmail] = useState("");
  const [assignToEmail, setAssignToEmail] = useState("");
  const [assignToType, setAssignToType] = useState("");
  const [customer, setCustomer] = useState({});
  const [executive, setExecutive] = useState({});
  const [category, setCategory] = useState({});
  const [subCategory, setSubCategory] = useState({});
  const [priority, setPriority] = useState({});
  const [description, setDescription] = useState({});
  const [fileArr, setFileArr] = useState([]);
  const [showFileArr, setShowFileArr] = useState([]);
  const history = useHistory();
  const matchURL = useRouteMatch();

  const subCategoryRef = useRef(null);
  const customerRef = useRef(null);
  const assignedRef = useRef(null);
  const ticketCategoryRef = useRef(null);
  const priorityRef = useRef(null);
  const descriptionRef = useRef(null);

  const [goBackLink, setGoBackLink] = useState("/dashboard");
  const [executiveUrl, setExecutiveURL] = useState("");

  const [editData, setEditData] = useState({
    ticketId: "",
    customerId: "",
    email: "",
    role_type: "",
    ticketCategory: "",
    subcategory: "",
    priority: "",
    description: "",
    assignedTo: "",
    status: "",
  });

  useEffect(() => {
    let id = matchURL.params.id;
    console.log(id);

    let custUrl = environment.dap_url + "users/getUsersByfilters";
    let execUrl = environment.dap_url + "support/getAssignedTo";
    let user = JSON.parse(localStorage.getItem("user"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let isPartner = localStorage.getItem("isPartnerLogin");
    let filter = { userType: "CUSTOMER_USER", parentId: user.createdById };
    if (localStorage.getItem("isPartnerLogin")) {
      console.log("partner");
      execUrl =
        environment.dap_url + "support/getAssignedToById?id=" + user._id;
      filter = { userType: "CUSTOMER_USER", parentId: user._id };
      setGoBackLink("/supports");
    }
    if (localStorage.getItem("isSupportAdmin")) {
      execUrl =
        environment.dap_url +
        "support/getAssignedToById?id=" +
        user.createdById;
      filter = { userType: "CUSTOMER_USER", parentId: user.createdById };
      setGoBackLink("/support-tickets");
    }
    if (userDetails.data.authority == "SYS_ADMIN") {
      execUrl =
        environment.dap_url + "support/getAssignedToById?id=" + user._id;
      filter = { userType: "CUSTOMER_USER" };
      setGoBackLink("/supports");
    }

    axios
      .get(environment.dap_url + "support/getSupportById?id=" + id)
      .then((res) => {
        console.log("ticketEdit", res);
        // console.log(res.data[0]);
        let ticket = res.data[0];

        setCustomerEmail(ticket.customer_details[0].email);
        if (ticket.executive_details.length > 0) {
          setAssignToEmail(ticket.executive_details[0].email);
          setAssignToType(ticket.executive_details[0].userType);
          setExecutive({
            label:
              ticket.executive_details[0].userFirstName +
              " " +
              ticket.executive_details[0].userLastName,
            value: ticket.executive_details[0]._id,
          });
        }
        setCustomer({
          label:
            ticket.customer_details[0].userFirstName +
            " " +
            ticket.customer_details[0].userLastName,
          value: ticket.customer_details[0]._id,
        });
        setCategory({
          label: ticket.ticketCategory,
          value: ticket.ticketCategory,
        });
        setSubCategory({
          label: ticket.subcategory,
          value: ticket.subcategory,
        });
        setPriority({ label: ticket.priority, value: ticket.priority });
        setDescription(ticket.description);

        setEditData({
          ticketId: ticket.ticketId,
          customerId: ticket.customerId,
          email: ticket.email,
          role_type: ticket.role_type,
          ticketCategory: ticket.ticketCategory,
          subcategory: ticket.subcategory,
          priority: ticket.priority,
          description: ticket.description,
          assignedTo: ticket.assignedTo,
          status: ticket.status,
          file: ticket.file,
        });
        // setCustomerEmail(res.data[0].email)
        setData({
          ticketId: ticket.ticketId,
          customerId: ticket.customerId,
          email: ticket.email,
          role_type: ticket.role_type,
          ticketCategory: ticket.ticketCategory,
          subcategory: ticket.subcategory,
          priority: ticket.priority,
          description: ticket.description,
          assignedTo: ticket.assignedTo,
          status: ticket.status,
          file: ticket.file,
        });
        setShowFileArr(ticket.file);
      });

    axios
      .post(custUrl, { filters: filter })
      .then((res) => {
        console.log(res);
        setOptionForName(
          res.data.map((user) => {
            return {
              name: "customerId",
              value: user._id,
              label: user.userFirstName + " " + user.userLastName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(execUrl)
      .then((res) => {
        setOptionsForAssign(
          res.data.map((user) => {
            return {
              name: "assignedTo",
              value: user._id,
              label: user.userFirstName + " " + user.userLastName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });

    axios
      .get(environment.dap_url + "support/getCategory")
      .then((res) => {
        setOptionForTicketCategory(
          res.data.map((item) => {
            return {
              name: "ticketCategory",
              value: item.categoryName,
              label: item.categoryName,
            };
          })
        );
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const formValidation = () => {
    const ticketError = {};
    const subCategoryError = {};
    const customerError = {};
    const priorityError = {};

    let isValid = true;
    // if (!data.ticketCategory) {
    //     ticketError.error = "Ticket Category is required";
    //     isValid = false;
    // }
    // if (!data.subcategory) {
    //     subCategoryError.error = "Sub Category is required";
    //     isValid = false;
    // }
    // if (!data.customerName) {
    //     customerError.error = "Customer Name is required";
    //     isValid = false;
    // }
    if (!data.priority) {
      priorityError.error = "Priority is required";
      isValid = false;
    }

    setTicketError(ticketError);
    setSubCategoryError(subCategoryError);
    setCustomerError(customerError);
    setPriorityError(priorityError);

    return isValid;
  };

  const [data, setData] = useState({
    ticketId: "",
    customerId: "",
    email: "",
    role_type: "",
    ticketCategory: "",
    subcategory: "",
    priority: "",
    description: "",
    assignedTo: "",
    status: "",
    file: [],
  });

  const optionsForPriority = [
    { name: "priority", value: "Low", label: "Low" },
    { name: "priority", value: "Medium", label: "Medium" },
    { name: "priority", value: "High", label: "High" },
  ];

  const getUserById = (id, uType) => {
    axios
      .get(environment.dap_url + "users/" + id)
      .then((res) => {
        console.log(res);
        if (uType == "customer") {
          setCustomerEmail(res.data.email);
        } else {
          setAssignToEmail(res.data.email);
          setAssignToType(res.data.userType);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const handleChange = (selectedOption) => {
    console.log(selectedOption);
    if (selectedOption.name === "ticketCategory") {
      subCategoryRef.current.state.value = "";
      setCategory({ label: selectedOption.value, value: selectedOption.value });
      axios
        .get(
          environment.dap_url +
            "support/getSubCategoryByCategory/?categoryName=" +
            selectedOption.value
        )
        .then((res) => {
          setOptionForSubCategory(
            res.data.map((item) => {
              return {
                name: "subcategory",
                value: item.subCategoryName,
                label: item.subCategoryName,
              };
            })
          );
        })
        .catch((err) => {
          console.log(err);
        });
    }
    if (selectedOption.name === "subcategory") {
      setData({ ...data, [selectedOption.name]: selectedOption.value });

      setSubCategory({
        label: selectedOption.value,
        value: selectedOption.value,
      });
      // setPriority({label:ticket.priority,value:ticket.priority})
    }
    if (selectedOption.name === "assignedTo") {
      getUserById(selectedOption.value, "executive");
      setData({ ...data, [selectedOption.name]: selectedOption.value });
      setExecutive({
        label: selectedOption.label,
        value: selectedOption.value,
      });
      setData({ ...data, [selectedOption.name]: selectedOption.label });
    }
    if (selectedOption.name === "customerId") {
      console.log(selectedOption.value);
      getUserById(selectedOption.value, "customer");
      setCustomer({ label: selectedOption.label, value: selectedOption.value });
      setData({ ...data, [selectedOption.name]: selectedOption.value });
      // setCustomerEmail(selectedOption.label)
    }
    if (selectedOption.name === "priority") {
      setPriority({ label: selectedOption.label, value: selectedOption.value });
      setData({ ...data, [selectedOption.name]: selectedOption.value });
    }
    setData({ ...data, [selectedOption.name]: selectedOption.value });
  };

  const handleChangeforText = (e) => {
    setDescription(e.target.value);
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const handleCancel = () => {
    setData({
      customerId: "",
      assignedTo: "",
      assignedToName: "",
      ticketCategory: "",
      subcategory: "",
      priority: "",
      attachment: "",
      description: "",
      file: [],
    });
    setUploadFiles([]);
    subCategoryRef.current.state.value = "";
    customerRef.current.state.value = "";
    assignedRef.current.state.value = "";
    ticketCategoryRef.current.state.value = "";
    priorityRef.current.state.value = "";
    descriptionRef.current.value = "";
    // inputRef.current.value = "";
  };

  const inputRef = useRef(null);
  const handleChangeForFile = (e) => {
    const file = e.target.files[0];
    const uploadFile = [...uploadFiles];
    const f = [...fileArr];
    f.push(URL.createObjectURL(e.target.files[0]));
    setFileArr(f);
    uploadFile.push(file);
    setUploadFiles(uploadFile);
    setData({ ...data, [e.target.name]: uploadFile });
  };

  const handelSubmit = (e) => {
    const isValid = formValidation();
    if (isValid) {
      e.preventDefault();
      setLoading(true);
      let status = "assigned";
      if (data.assignedTo === "") {
        data.assignedTo = "N/A";
        status = "created";
      }
      const formData = new FormData();
      formData.append("status", status);
      formData.append("assignedTo", data.assignedTo);
      formData.append("ticketCategory", data.ticketCategory);
      formData.append("subcategory", data.subcategory);
      formData.append("priority", data.priority);
      formData.append("description", data.description);
      let farr = [];
      showFileArr.forEach((f) => {
        farr.push(f);
      });
      formData.append("file", farr);

      let reqBody = {
        status: status,
        assignedTo: data.assignedTo,
        assignedToName: data.assignedToName,
        ticketCategory: data.ticketCategory,
        subcategory: data.subcategory,
        priority: data.priority,
        description: data.description,
      };

      for (let i = 0; i < uploadFiles.length; i++) {
        formData.append("attachment", uploadFiles[i]);
      }
      formData.append("attachment", []);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };

      console.log(
        formData.forEach((value, key) => {
          console.log(key + " " + value);
        })
      );

      axios
        .post(
          environment.dap_url + "support/update?id=" + matchURL.params.id,
          formData,
          config
        )
        .then((res) => {
          console.log(res);
          Swal.fire({
            icon: "success",
            title: "Ticket Updated",
            showConfirmButton: false,
            timer: 1500,
          }).then((result) => {
            handleCancel();
            history.push(goBackLink);
          });
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      e.preventDefault();
      // setLoading(false);
    }
  };
  console.log("showFileArr", showFileArr);
  const removePrevious = (e, i) => {
    console.log(i);
    let fArr = [...showFileArr];
    fArr.splice(i, 1);
    setShowFileArr(fArr);
    data.file = fArr;
    setData(data);
  };
  const remove = (e, i) => {
    console.log(i);
    let f = [...fileArr];
    const uploadFile = [...uploadFiles];
    uploadFile.splice(i, 1);
    setUploadFiles(uploadFile);
    f.splice(i, 1);
    console.log(f);
    setFileArr(f);
    setData({ ...data, ["attachment"]: uploadFile});
  };

  return (
    <>
      <div className="container-fluid">
        <NavbarNew />
        <LinkContainer
          to={goBackLink}
          style={{ marginLeft: "50px", marginTop: "20px" }}
        >
          <Button variant="light" className="btn btn-light">
            Go Back
          </Button>
        </LinkContainer>
        <div
          className="mx-3 p-3 bg-white"
          style={{ marginTop: "75px", color: "black" }}
        >
          <div className="row"></div>
          <div>
            <h4 style={{ display: "inline" }} className="card-title">
              Edit Tickets :
            </h4>
          </div>
          <div style={{ marginLeft: "4%", marginRight: "4%" }}>
            <Form encType="multipart/form-data">
              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Customer Name:</Form.Label>
                    <Select
                      ref={customerRef}
                      options={optionForName}
                      onChange={handleChange}
                      value={customer}
                    />
                    <div>
                      {Object.keys(customerError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{customerError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={customerEmail}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Date: </Form.Label>
                    <Form.Control
                      value={new Date().toLocaleDateString()}
                      disabled
                    />
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Assigned to:</Form.Label>
                    <Select
                      ref={assignedRef}
                      onChange={handleChange}
                      options={optionsForAssign}
                      value={executive}
                    />
                  </Form.Group>
                </div>

                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Email:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={assignToEmail}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>

                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Type:</Form.Label>
                    <input
                      name="email"
                      class="form-control"
                      type="text"
                      value={assignToType}
                      readOnly
                    ></input>
                  </Form.Group>
                </div>
              </div>

              <div className="row">
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Ticket Category:</Form.Label>
                    <Select
                      ref={ticketCategoryRef}
                      onChange={handleChange}
                      options={optionForTicketCategory}
                      value={category}
                    />
                    <div>
                      {Object.keys(ticketError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{ticketError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Sub Category:</Form.Label>

                    <Select
                      ref={subCategoryRef}
                      onChange={handleChange}
                      options={optionForSubCategory}
                      value={subCategory}
                    />
                    <div>
                      {Object.keys(subCategoryError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>
                            {subCategoryError[key]}
                          </p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
                <div className="col-4">
                  <Form.Group>
                    <Form.Label>Priority:</Form.Label>
                    <Select
                      ref={priorityRef}
                      onChange={handleChange}
                      options={optionsForPriority}
                      value={priority}
                    />
                    <div>
                      {Object.keys(priorityError).map((key) => {
                        return (
                          <p style={{ color: "red" }}>{priorityError[key]}</p>
                        );
                      })}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-3">
                  <Form.Group>
                    <Form.Label>Attachment:</Form.Label>
                    <br></br>
                    <input
                      onChange={handleChangeForFile}
                      ref={inputRef}
                      name="attachment"
                      type="file"
                      id="formFileMultiple"
                      multiple
                      accept="image/png, image/gif, image/jpeg,image/svg"
                      style={{ display: "none" }}
                    />
                    <Form.Label htmlFor="formFileMultiple">
                      <button
                        type="button"
                        class="btn btn-primary"
                        onClick={() => inputRef.current.click()}
                        style={{ margin: "5px" }}
                      >
                        Add Pictures
                      </button>
                    </Form.Label>

                    <div style={{ display: "flex", margin: "10px" }}>
                      {data.file.map((f, i) => (
                        <div
                          style={{
                            width: "auto",
                            height: "auto",
                            margin: "5px",
                            border: "1px solid black",
                            position: "relative",
                          }}
                        >
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => {
                              removePrevious(e, i);
                            }}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                          <img src={environment.dap_url + f} style={{ width: "100px",maxHeight:"100px" }} />
                        </div>
                      ))}
                      {fileArr.map((f, i) => (
                        <div
                          style={{
                            width: "auto",
                            height: "auto",
                            margin: "5px",
                            border: "1px solid black",
                            position: "relative",
                          }}
                        >
                          <button
                            className="btn btn-sm btn-danger"
                            onClick={(e) => remove(e, i)}
                            style={{
                              position: "absolute",
                              top: "5px",
                              right: "5px",
                            }}
                          >
                            <i className="fa fa-trash"></i>
                          </button>
                          <img src={f} style={{ width: "100px",maxHeight:"100px" }} />
                        </div>
                      ))}
                    </div>
                  </Form.Group>
                </div>
              </div>
              <div className="row">
                <div className="col-8">
                  <Form.Group>
                    <Form.Label> Description:</Form.Label>
                    <textarea
                      ref={descriptionRef}
                      onChange={handleChangeforText}
                      value={description}
                      name="description"
                      class="form-control"
                      rows="3"
                    ></textarea>
                  </Form.Group>
                </div>
              </div>
              <div className="col-4" style={{ marginTop: "2%" }}>
                <button
                  type="submit"
                  class="btn btn-primary"
                  onClick={handelSubmit}
                >
                  UPDATE TICKET
                </button>
                {/* <button
                  onClick={handleCancel}
                  type="button"
                  class="btn btn-danger"
                >
                  CANCEL
                </button> */}
              </div>
            </Form>
          </div>
        </div>
      </div>
    </>
  );
};

export default EditTicket;
